export const Language = {
  en: {
    titlex: "Courses",
    button_next: "Next step",
  },
  de: {
    titlex: "Kurse",
    button_next: "Zum nächsten Schritt",
  },
  du: {
    titlex: "Cursussen",
    button_next: "Volgende stap",
  },
  hu: {
    titlex: "Tanfolyamok",
    button_next: "Következő lépés",
  },
  fr: {
    titlex: "Cours",
    button_next: "Étape suivante",
  },
  es: {
    titlex: "Cursos",
    button_next: "Siguiente paso",
  },
  pt: {
    titlex: "Cursos",
    button_next: "Próximo passo",
  },
  it: {
    titlex: "Corsi",
    button_next: "Prossimo passo",
  },
  po: {
    titlex: "Kursy",
    button_next: "Następny krok",
  },
  ru: {
    titlex: "Курсы",
    button_next: "Следующий шаг",
  },
  bg: {
    titlex: "Курсове",
    button_next: "Следваща стъпка",
  },
  gr: {
    titlex: "Μαθήματα",
    button_next: "Επόμενο βήμα",
  },
  tr: {
    titlex: "Kurslar",
    button_next: "Sonraki adım",
  },
  cz: {
    titlex: "Kurzy",
    button_next: "Další krok",
  },
  ro: {
    titlex: "Cursuri",
    button_next: "Pasul următor",
  },
  rshr: {
    titlex: "Tečajevi",
    button_next: "Sljedeći korak",
  },
};
